exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-overlay{position:fixed;top:0;left:0;z-index:1;width:100%;height:100%;background-color:rgba(0,0,0,.7)}", "", {"version":3,"sources":["/Users/hangz/Work/projects/vision-h5/node_modules/vant/es/overlay/index.css"],"names":[],"mappings":"AAAA,aAAa,eAAe,MAAM,OAAO,UAAU,WAAW,YAAY,+BAA+B,CAAC","file":"index.css","sourcesContent":[".van-overlay{position:fixed;top:0;left:0;z-index:1;width:100%;height:100%;background-color:rgba(0,0,0,.7)}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--8-1!./node_modules/vant/es/overlay/index.css
// module id = 0bSH
// module chunks = 212